<div class="fixed bottom-24 left-1/2 z-100 flex -translate-x-1/2 flex-col gap-20">
  @for (toast of toastService.toasts(); track $index) {
    <div
      class="flex h-48 w-[340px] items-center gap-12 border-0.7 py-12 pl-12 pr-8 shadow-toast-message"
      [ngClass]="{
        'border-secondary-green-50 bg-secondary-green-100': toast.type === 'success',
        'border-secondary-crimson-30 bg-secondary-crimson-50': toast.type === 'danger',
        'border-brand-50 bg-brand-100': toast.type === 'info'
      }"
    >
      @switch (toast.type) {
        @case ('success') {
          <svg-icon [src]="'images/Success_20px.svg'" svgClass="fill-secondary-green-800"></svg-icon>
        }
        @case ('danger') {
          <svg-icon [src]="'images/Warning_20px.svg'" svgClass="fill-secondary-crimson-800"></svg-icon>
        }
        @case ('info') {
          <svg-icon [src]="'images/Info_20px.svg'" svgClass="fill-brand-700"></svg-icon>
        }
      }
      <div class="grow text-body-sm-400 text-secondary-green-950">{{ toast.message }}</div>
      <svg-icon
        class="cursor-pointer"
        [src]="'images/Close_20px.svg'"
        svgClass="fill-secondary-greys-black"
        (click)="remove(toast.id)"
      ></svg-icon>
    </div>
  }
</div>
